import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  TablePagination,
  Typography,
} from "@mui/material";
import React from "react";
import ReportCptCodeCards from "../ReportCptCodeCards";
import InProgressCptCode from "../InProgressCptCode";
import { useSelector } from "react-redux";
import { getCptCodeSubtitleText } from "../../utils/helpers";
import AvatarWithName from "../AvatarWithName";
import Cpt98977Content from "../Cpt98977Content";
import RectangleSkeletons from "../RectangleSkeletons";
import Cpt98980Content from "../Cpt98980Content";
import Cpt98975Content from "../Cpt98975Content";
import Skeleton98977 from "../Skeleton98977";
import Skeleton98980 from "../Skeleton98980";
import { useNavigate } from "react-router-dom";

const CptIndividualViewContent = ({
  setSelectedCptFilters,
  selectedCptFilters,
  clickFilterHandler,
  activeCptCodeTab,
  openCptIndividualViewHandler,
  cptCodesPage,
  cptCodesPageHandler,
  cptCodesPageSize,
  cptCodesRowsPerPageHandler,
  selectedCptCode,
  payerValue,
  assignedTo,
  agencyId,
  page,
  selectedMonthValue,
  smartSortEnabled,
  openCptIndividualView = false,
}) => {
  const navigate = useNavigate();

  const getReportCptCodesList = useSelector(
    (state) => state.getReportCptCodesList
  );
  const {
    loading: loadingCptCodes,
    error: errorCptCodes,
    reportCptCodesList,
  } = getReportCptCodesList;

  const getCptCodeDetail = useSelector((state) => state.getCptCodeDetail);
  const {
    loading: loadingCptDetail,
    error: errorCptDetail,
    cptCodeDetail,
  } = getCptCodeDetail;

  const getAgencyDetail = useSelector((state) => state.getAgencyDetail);
  const { agencyDetail } = getAgencyDetail;

  const patientNavigateHandler = () => {
    navigate(`/patient/${selectedCptCode?.patient?.id}?tab=overview`);
  };

  return (
    <Box display="flex" alignItems="flex-start" gap="18px" height="100%">
      <Stack
        maxWidth={362}
        width="100%"
        gap="16px"
        borderRadius="8px"
        border="1px solid #EBEBEB"
        height="100%"
      >
        <ReportCptCodeCards
          setSelectedCptFilters={setSelectedCptFilters}
          selectedCptFilters={selectedCptFilters}
          clickFilterHandler={clickFilterHandler}
          padding="16px 16px 0"
          smartSortEnabled={smartSortEnabled}
        />
        <InProgressCptCode
          activeTab={activeCptCodeTab}
          openCptIndividualViewHandler={openCptIndividualViewHandler}
          padding="16px 16px 0"
          below1200Screen={true}
          selectedCptCode={selectedCptCode}
          smartSortEnabled={smartSortEnabled}
          openCptIndividualView={openCptIndividualView}
        />
        {!loadingCptCodes && reportCptCodesList?.cpt_codes?.length ? (
          <Box>
            <TablePagination
              component="div"
              count={
                (smartSortEnabled
                  ? reportCptCodesList?.includedCount
                  : reportCptCodesList?.count) || 0
              }
              page={cptCodesPage}
              onPageChange={cptCodesPageHandler}
              rowsPerPage={cptCodesPageSize}
              onRowsPerPageChange={cptCodesRowsPerPageHandler}
              rowsPerPageOptions={[10]}
            />
          </Box>
        ) : (
          <></>
        )}
      </Stack>
      {/* INDIVIDUAL CONTENT FOR CPT CODES */}
      <Stack width="100%" gap="24px" height="100%">
        <Stack>
          <Typography variant="h5" fontSize="2rem">
            CPT Code {selectedCptCode?.cpt_code}
          </Typography>
          <Typography variant="body1" color="secondary">
            {" "}
            {getCptCodeSubtitleText(selectedCptCode?.cpt_code)}
          </Typography>
          <Box display="flex" alignItems="center" gap="4px" padding="6px 0">
            <Typography variant="body2">Patient :</Typography>
            <AvatarWithName
              columnGap="4px"
              size={20}
              avatarFontSize={12}
              name={selectedCptCode?.patient?.name}
              imageURL={selectedCptCode?.patient?.profile_picture_url}
              avatarBgColor={selectedCptCode?.patient.avatar_color}
              clickable={true}
              patientNavigateHandler={patientNavigateHandler}
            />
          </Box>
        </Stack>
        {loadingCptDetail ? (
          selectedCptCode?.cpt_code === "98977" ? (
            <Skeleton98977 />
          ) : selectedCptCode?.cpt_code === "98975" ? (
            <Stack gap="4px">
              <RectangleSkeletons totalRows={1} height={58} />
              <RectangleSkeletons totalRows={1} height={58} />
            </Stack>
          ) : (
            <Skeleton98980 />
          )
        ) : (
          <>
            {cptCodeDetail && selectedCptCode?.cpt_code === "98975" && (
              <Cpt98975Content
                showHeading={false}
                patientDetail={selectedCptCode?.patient}
              />
            )}

            {cptCodeDetail && selectedCptCode?.cpt_code === "98977" && (
              <Cpt98977Content
                showHeading={false}
                cptCodeDetail={cptCodeDetail?.cpt_code}
              />
            )}

            {(selectedCptCode?.cpt_code === "98980" ||
              selectedCptCode?.cpt_code === "98981") && (
              <Cpt98980Content
                cptCodeDetail={cptCodeDetail?.cpt_code}
                selectValue={selectedMonthValue}
                patientDetail={selectedCptCode?.patient}
                showHeading={false}
                payerValue={payerValue}
                assignedTo={assignedTo}
                agencyId={agencyId}
                cptCodesPage={cptCodesPage}
                selectedCptFilters={selectedCptFilters}
                smartSortEnabled={smartSortEnabled}
                openCptIndividualView={openCptIndividualView}
              />
            )}
          </>
        )}
      </Stack>
    </Box>
  );
};

export default CptIndividualViewContent;
